import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { AuthFrame } from "./AuthFrame";
import { useSession } from "../../services/SessionContext";

export function ForgotPasswordPage() {
  const { requestPasswordReset } = useSession();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  function submit(event: React.FormEvent) {
    event.preventDefault();
    setError("");
    setMessage("");
    try {
      requestPasswordReset(email);
      setMessage("Password reset instructions are ready for your verified email address.");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Password reset failed.");
    }
  }

  return (
    <AuthFrame title="Forgot password" subtitle="Request a reset for your account email.">
      <form className="space-y-4" onSubmit={submit}>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            autoComplete="email"
            inputMode="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        {error ? <p className="text-sm font-medium text-red-700">{error}</p> : null}
        {message ? <p className="text-sm font-medium text-field-600">{message}</p> : null}
        <Button className="w-full" type="submit">
          Send reset instructions
        </Button>
      </form>
      <p className="mt-5 text-sm text-slate-600">
        <Link className="font-medium text-navy-900 hover:underline" to="/auth/sign-in">
          Return to sign in
        </Link>
      </p>
    </AuthFrame>
  );
}
